import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-frontend-publication-page',
  templateUrl: './frontend-publication-page.component.html',
  styleUrls: ['./frontend-publication-page.component.scss']
})
export class FrontendPublicationPageComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
